import {
  TChartApiDataRequest,
  TChartApiDataResponse,
  TColumnsApiDataResponse,
  TDownloadApiDataLinkResponse,
  TDownloadApiDataRequest,
  TFiltersApiDataRequest,
  TFiltersApiDataResponse,
  TListApiDataRequest,
  TListApiDataResponse,
} from '../types/ApiData';
import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { config } from '/src/config';

export class ApiDataService {
  /**
   * List ApiData
   */
  public static list(req: TListApiDataRequest): CancelablePromise<TListApiDataResponse> {
    return __request<TListApiDataResponse>(OpenAPI, {
      method: 'POST', // Note. Recommendation is using GET for fetch data but filter can be too long for URI
      url: '/api-data',
      body: req,
      useArrayBrackets: true,
    });
  }

  /**
   * Filter values for ApiData
   */
  public static filters(req: TFiltersApiDataRequest): CancelablePromise<TFiltersApiDataResponse> {
    return __request<TFiltersApiDataResponse>(OpenAPI, {
      method: 'GET',
      url: '/api-data/filters',
      query: req,
      useArrayBrackets: true,
    });
  }

  /**
   * Available columns for ApiData
   */
  public static columns(): CancelablePromise<TColumnsApiDataResponse> {
    return __request<TColumnsApiDataResponse>(OpenAPI, {
      method: 'GET',
      url: '/api-data/columns',
      useArrayBrackets: true,
    });
  }

  /**
   * Get link for Download ApiData as CSV
   */
  public static getDownloadLink(req?: TDownloadApiDataRequest): CancelablePromise<TDownloadApiDataLinkResponse> {
    return new CancelablePromise((resolve, reject, onCancel) => {
      const requestPromise = __request<TDownloadApiDataLinkResponse>(OpenAPI, {
        method: 'POST',
        url: '/api-data/getDownloadLink',
        body: req,
        useArrayBrackets: true,
      });

      onCancel(() => {
        requestPromise.cancel();
      });

      requestPromise
        .then((response) => {
          resolve({
            ...response,
            url: new URL(response.url, config.api.url).href, // Enreach url with actual base
          });
        })
        .catch(reject);
    });
  }

  /**
   * Data for charts
   */
  public static chartsData(req: TChartApiDataRequest): CancelablePromise<TChartApiDataResponse> {
    return __request<TChartApiDataResponse>(OpenAPI, {
      method: 'POST', // Note. Recommendation is using GET for fetch data but filter can be too long for URI
      url: '/api-data/charts',
      body: req,
      useArrayBrackets: true,
    });
  }
}
